"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stickybits_1 = require("stickybits");
var BaseComponent_1 = require("../BaseComponent");
var Sticky = /** @class */ (function (_super) {
    __extends(Sticky, _super);
    function Sticky($view) {
        var _this = _super.call(this, $view) || this;
        _this.bind();
        _this.offset = $view.data('offset') || 85;
        return _this;
    }
    Sticky.prototype.bind = function () {
        stickybits_1.default(this.$view, {
            stickyBitStickyOffset: this.offset
        });
    };
    return Sticky;
}(BaseComponent_1.default));
exports.default = Sticky;
